import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { platformApi } from '../../api/platform';
import { useAuth } from '../../auth/AuthProvider';
import { PageHeader, LoadingState } from '../../components/Layout';

export default function PlatformOverview() {
  const { getToken } = useAuth();
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const token = await getToken();
        const data = await platformApi.listShops(token);
        if (!cancelled) {
          setShops(data);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [getToken]);

  if (loading) {
    return <LoadingState />;
  }

  const activeShops = shops.filter((shop) => shop.is_active).length;

  return (
    <>
      <PageHeader
        title="Platform overview"
        description="Manage shops and assign admins. Merchants create stores when they sign up."
        actions={
          <Link to="/platform/shops" className="btn btn-primary">
            Manage shops
          </Link>
        }
      />

      <div className="stats-grid">
        <div className="stat-card">
          <div className="label">Total shops</div>
          <div className="value">{shops.length}</div>
        </div>
        <div className="stat-card">
          <div className="label">Active shops</div>
          <div className="value">{activeShops}</div>
        </div>
        <div className="stat-card">
          <div className="label">Inactive shops</div>
          <div className="value">{shops.length - activeShops}</div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h3 style={{ margin: '0 0 1rem', fontSize: '1rem' }}>Recent shops</h3>
          {shops.length === 0 ? (
            <p style={{ margin: 0, color: 'var(--text-muted)' }}>No shops yet.</p>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Slug</th>
                  <th>Schema</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {shops.slice(0, 5).map((shop) => (
                  <tr key={shop.id}>
                    <td>
                      <Link to={`/platform/shops/${shop.id}`}>{shop.name}</Link>
                    </td>
                    <td>{shop.slug}</td>
                    <td>
                      <span className="schema-pill">{shop.schema_name}</span>
                    </td>
                    <td>
                      <span className={`badge ${shop.is_active ? 'badge-success' : 'badge-muted'}`}>
                        {shop.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
